import React, { Component } from 'react'

import {
  MainContainer,
  CoverPageContainer,
  SubHeading
} from './styledComponents'



export default class LandingSection extends Component {
  render() {
    return (
      <MainContainer id="careers-landing-section">
        <CoverPageContainer>
          <SubHeading>Investor Relations</SubHeading>
        </CoverPageContainer>
      </MainContainer>
    )
  }
}
